import React, { Component } from "react";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

class TabsTwo extends Component{
    render(){
        let 
        tab1 = "Skills",
        tab2 = "Education & Certification";
        const { tabStyle } = this.props
        return(
            <div>
                {/* Start Tabs Area */}
                <div className="tabs-area">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <Tabs>
                                    <TabList  className={`${tabStyle}`}>
                                        <Tab>{tab1}</Tab>
                                        <Tab>{tab2}</Tab>
                                    </TabList>

                                    <TabPanel>
                                        <div className="single-tab-content">
                                            <ul>
                                                <li>
                                                    <span style={{fontWeight: '700'}}> Languages & Frameworks </span> <br />
                                                    Javascript, Python, HTML, CSS <br />
                                                    React, Express, Django <br />
                                                </li>
                                                <li>
                                                    <span style={{fontWeight: '700'}}> Database Management Systems </span> <br />
                                                    MongoDB, PostgresQL, MySQL
                                                </li>
                                                <li>
                                                <span style={{fontWeight: '700'}}> RESTful API design and implementation </span> <br />
                                                </li>
                                                <li>
                                                <span style={{fontWeight: '700'}}> Authentication and authorization techniques </span> <br />
                                                JWT, OAuth, Custom middleware <br />
                                                Experienced in implementing secure API endpoints

                                                    
                                                </li>
    
                                            </ul>
                                        </div>
                                    </TabPanel>

                                    <TabPanel>
                                    <div className="single-tab-content">
                                           <ul>
                                                <li>
                                                    <span style={{fontWeight: '600'}}> Certificate of Completion (420 Hours) - General Assembly </span> <br />2023
                                                </li>
                                                <li>
                                                    <span style={{fontWeight: '600'}}> BS in Exercise Science - Virginina Commonwealth University </span> <br />2018
                                                </li>
                                           </ul>
                                       </div>
                                    </TabPanel>


                        
                                    
                                </Tabs>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Tabs Area */}
            </div>
        )
    }
}



export default TabsTwo;